import { Action, Module, Mutation } from 'vuex-module-decorators'
import { cloneDeep, includes, orderBy, some } from 'lodash'
import { referenceApi, SystemCode } from '@/api'
import BaseStore from '@/store/BaseStore'
import { AlertCodeILC00024, Sort, SortOrder } from '@/types'
import { ReferenceListItem } from '@/api/models/reference/ReferenceListItem'
import { AlertFactory } from '@/factory'

export interface ReferenceSearchConditionsItem {
  searchDateType: string
  startDate: string
  endDate: string
  contentTypeText: string
  freeKeyword: string
}

export const defaultReferenceSearchConditions: ReferenceSearchConditionsItem = {
  searchDateType: '1',
  startDate: '',
  endDate: '',
  contentTypeText: '',
  freeKeyword: ''
}

@Module({
  name: 'ReferenceListStore',
  namespaced: true,
  stateFactory: true
})
export default class ReferenceListStore extends BaseStore {
  items: ReferenceListItem[] = []

  searchConditions: ReferenceSearchConditionsItem = cloneDeep(
    defaultReferenceSearchConditions
  )

  selectedIds: number[] = []

  sortNames: string[] = []

  sortOrders: SortOrder[] = []

  get getItems(): ReferenceListItem[] {
    return this.items
  }

  // TODO ここその内綺麗にしたい
  get sortedItems(): ReferenceListItem[] {
    if (this.sortNames.length === 0) return this.items

    return orderBy<ReferenceListItem>(
      this.items,
      (item: ReferenceListItem) => {
        if (includes(this.sortNames, 'managementNo')) {
          return Number(item.managementNo)
        } else if (
          some(['answerStage', 'level', 'database', 'opac'], (item: string) => {
            return item === this.sortNames[0]
          })
        ) {
          // eslint-disable-next-line standard/computed-property-even-spacing
          return (item[
            this.sortNames[0] as keyof ReferenceListItem
          ] as SystemCode)?.shortName
        } else {
          return item[this.sortNames[0] as keyof ReferenceListItem]
        }
      },
      this.sortOrders as 'asc' | 'desc'[]
    )
  }

  get getSearchConditions(): ReferenceSearchConditionsItem {
    return this.searchConditions
  }

  get getSelectedIds(): number[] {
    return this.selectedIds
  }

  @Mutation
  public reset() {
    this.items = []
    this.searchConditions = cloneDeep(defaultReferenceSearchConditions)
    this.selectedIds = []
    this.sortNames = []
    this.sortOrders = []
  }

  @Mutation
  public setItems(items: ReferenceListItem[]) {
    this.items = items
  }

  @Mutation
  public sort(sort: Sort) {
    this.sortNames = sort.names
    this.sortOrders = sort.orders
  }

  @Mutation
  public setSearchConditions(searchConditions: ReferenceSearchConditionsItem) {
    this.searchConditions = searchConditions
  }

  @Mutation
  public setSearchDateType(value: string) {
    this.searchConditions.searchDateType = value
  }

  @Mutation setStartDate(value: string) {
    this.searchConditions.startDate = value
  }

  @Mutation setEndDate(value: string) {
    this.searchConditions.endDate = value
  }

  @Mutation setContentTypeText(value: string) {
    this.searchConditions.contentTypeText = value
  }

  @Mutation setFreeKeyword(value: string) {
    this.searchConditions.freeKeyword = value
  }

  @Mutation setSelectedIds(value: number[]) {
    this.selectedIds = value
  }

  @Action({ rawError: true })
  public async fetchAll(value: ReferenceSearchConditionsItem) {
    const items = await referenceApi.getReferences({
      searchConditions: value
    })

    if (items.length === 0) {
      // eslint-disable-next-line no-throw-literal
      throw [AlertFactory.create(AlertCodeILC00024, 'レファレンス事例')]
    }
    this.setItems(items)
  }
}
